/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';
import * as _ from 'lodash';

@Component({
  selector: 'ns-fund-by-broker-account',
  template: require('./fund-by-broker-account.component.html')
})

export class FundByBrokerAccountComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.contraName = this.appActions.getData('Acats.acatsFirmName');
  }

  ngOnInit() {
    // Sets max length on the form field based on the DTC number
    const specialRules = _.get(this.validation.schema, 'brokerAcctNumberDynamic.reduxSpecial');
    if(specialRules) {
      const matchedRule = this.validation.matchSpecialRule(specialRules);
      if(matchedRule) {
        this.form.inputs.contraAccountNumber.attr.maxLength = matchedRule.max;
      }
    }
  }

  difFundingMethod(event) {
    this.modal.difFunding();
  }

  fundLater(e) {
    this.flowManager.fundLaterRouting();
  }

  ngOnDestroy() {
    this.flowManager.resetPageError();
  }
}
